module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_property-desc.js
// module id = 48
// module chunks = 48 49 50 51